import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type SaveUserDetailsMutationVariables = Types.Exact<{
  userId: Types.Scalars['bigint']['input'];
  userObj: Types.Users_Set_Input;
}>;


export type SaveUserDetailsMutation = { __typename?: 'mutation_root', update_users?: { __typename?: 'users_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'users', id: number }> } | null };


export const SaveUserDetailsDocument = gql`
    mutation saveUserDetails($userId: bigint!, $userObj: users_set_input!) {
  update_users(where: {id: {_eq: $userId}}, _set: $userObj) {
    affected_rows
    returning {
      id
    }
  }
}
    `;
export type SaveUserDetailsMutationFn = Apollo.MutationFunction<SaveUserDetailsMutation, SaveUserDetailsMutationVariables>;

/**
 * __useSaveUserDetailsMutation__
 *
 * To run a mutation, you first call `useSaveUserDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveUserDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveUserDetailsMutation, { data, loading, error }] = useSaveUserDetailsMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      userObj: // value for 'userObj'
 *   },
 * });
 */
export function useSaveUserDetailsMutation(baseOptions?: Apollo.MutationHookOptions<SaveUserDetailsMutation, SaveUserDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveUserDetailsMutation, SaveUserDetailsMutationVariables>(SaveUserDetailsDocument, options);
      }
export type SaveUserDetailsMutationHookResult = ReturnType<typeof useSaveUserDetailsMutation>;
export type SaveUserDetailsMutationResult = Apollo.MutationResult<SaveUserDetailsMutation>;
export type SaveUserDetailsMutationOptions = Apollo.BaseMutationOptions<SaveUserDetailsMutation, SaveUserDetailsMutationVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/userManagement/queries/saveUserDetails.mutation.gql}
 */
export async function saveUserDetails(
  variables: SaveUserDetailsMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<SaveUserDetailsMutation['update_users']>
export async function saveUserDetails(
  variables: SaveUserDetailsMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<SaveUserDetailsMutation>
export async function saveUserDetails(
  variables: SaveUserDetailsMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<SaveUserDetailsMutation['update_users'] | SaveUserDetailsMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<SaveUserDetailsMutation>(
    SaveUserDetailsDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.update_users
}